import {Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {MapService} from '../../../core/map/map.service';
import {AccountsService} from '../../../core/accounts/accounts.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {CheckinsService} from '../../../core/checkins/checkins.service';

import { LogType } from '../../../models/logType';
import {RoutesService} from '../../../core/routes/routes.service';

import * as moment from 'moment';
import {AuthService} from '../../../core/auth/auth.service';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent implements OnInit, OnChanges {

  @Input('accountDetails') accountDetails: any;

  @Output('close') close = new EventEmitter<void>();

  notesForm: FormGroup;

  savingNote: boolean;

  noteTimestamp: Date;

  checkinForm: FormGroup;

  modalRef: BsModalRef;

  selectedCheckin: any;

  logTypes = Object.keys(LogType);

  accountToDelete: any;

  constructor(private fb: FormBuilder,
              private modalService: BsModalService,
              public authService: AuthService,
              private accountsService: AccountsService,
              private checkinsService: CheckinsService,
              private routesService: RoutesService,
              private mapService: MapService) { }

  ngOnInit() {}

  ngOnChanges() {
    this.notesForm = this.fb.group({
      notes: [this.accountDetails.notes]
    });

    this.checkinForm = this.fb.group({
      type: '',
      notes: ''
    });
  }

  addAccountToRoute(account) {
    this.routesService.addAccountToRoute(account);
  }

  checkIn(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  createCheckin(checkin) {
    this.checkinsService.create(this.accountDetails._id, checkin)
      .subscribe((newCheckin: any) => {
        this.accountDetails.checkins = [newCheckin, ...this.accountDetails.checkins];
        this.checkinForm.reset();
        this.modalRef.hide();
      }, err => {
        alert(err.error.message || 'An error occurred');
      });
  }

  getLastCheckin() {
    return moment.max(this.accountDetails.checkins.map(c => moment(c.date)));
  }

  getDaysBefore() {
    const min = moment.max(this.accountDetails.checkins.map(c => moment(c.date)));
    return (moment()).diff(min, 'days');
  }

  getStaticMap(accountDetails) {
    return `https://maps.googleapis.com/maps/api/staticmap?center=${accountDetails.coords[1]},${accountDetails.coords[0]}&zoom=16&size=600x200&maptype=hybrid&markers=S%7C${accountDetails.coords[1]},${accountDetails.coords[0]}&key=AIzaSyBbuvDuShPoFALZBSDp5J6ca9Z_EJALPHI`;
  }

  deleteAccount(template, account) {
    this.accountToDelete = account;
    this.modalRef = this.modalService.show(template);
  }

  confirmDeletion() {
    this.accountsService.delete(this.accountToDelete._id)
      .subscribe(() => {
        this.accountToDelete = null;
        this.modalRef.hide();
        this.close.next();
      }, err => {
        alert(err.error.message || 'An error occurred');
      });
  }

  deleteCheckin(e, checkin) {
    this.checkinsService.delete(this.accountDetails._id, checkin._id)
      .subscribe(() => {
        this.accountDetails.checkins = this.accountDetails.checkins.filter(c => c._id !== checkin._id);
      }, err => {
        alert(err.error.message || 'An error occurred');
      });
    e.stopPropagation();
  }

  editNotes(accountDetails, data) {
    this.savingNote = true;
    this.accountsService.edit(accountDetails._id, data)
      .subscribe(() => { this.savingNote = false; this.noteTimestamp = new Date(); }, err => { alert(err.error.message); });
  }

  locateAccount(accountDetails) {
    this.mapService.center(accountDetails.coords[1], accountDetails.coords[0]);
  }

  showCheckinDetails(e, template: TemplateRef<any>, checkin) {
    this.modalRef = this.modalService.show(template);
    this.selectedCheckin = checkin;
    e.preventDefault();
  }

  isAccountInRoute(account) {
    return this.routesService.isAccountInRoute(account);
  }

  onEdit(data) {
    this.accountsService.edit(this.accountDetails._id, data)
      .subscribe(() => {
        this.accountDetails = Object.assign({}, this.accountDetails, data);
      });
  }

  onCustomFieldEdit(value) {
    this.accountsService.editCustomField(this.accountDetails._id, value)
      .subscribe((fieldValue: any) => {
        const fieldValueToChange = this.accountDetails.customFields.find(f => f.field._id === fieldValue.field);
        if (fieldValueToChange) {
          fieldValueToChange.value = fieldValue;
        } else {
          this.accountDetails.customFields.values = [fieldValue, ...this.accountDetails.customFields.values];
        }
      });
  }

  hasCheckins() {
    return this.accountDetails.checkins && this.accountDetails.checkins.length;
  }

  navigateToAccount(account) {
    window.open(`https://www.google.com/maps?daddr=${account.coords[1]},${account.coords[0]}`, '_blank');
  }

}



// WEBPACK FOOTER //
// ./client/app/components/info-panel/account-details/account-details.component.ts